import tablelistApi from 'api/tablelistApi';

export default {
  /**
   * @param {String} venueId
   */
  listByVenueId(venueId, options = {}) {
    if (!venueId) throw new Error('venueId is required');

    return tablelistApi.get(`/v1/venues/${venueId}/active-inventory`, options);
  },

  /**
   * @param {String} venueId
   */
  listByCityId(cityId, options = {}) {
    if (!cityId) throw new Error('cityId is required');

    return tablelistApi.get(`/v1/cities/${cityId}/active-inventory`, options);
  },

  /**
   * @param {String} venueId
   */
  getById(id, options = {}) {
    if (!id) throw new Error('id is required');

    return tablelistApi.get(`/inventory/${id}`, options);
  }
};



// WEBPACK FOOTER //
// ./src/api/inventory/service.js